import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EySliderTypeEnum } from '@EYN/lib';

enum AdjustablePlanVariables {
	EXPENSES = 1,
	TIME = 2,
}

interface AdjustableVariable {
	label: string;
	header: string;
	popover: string;
	type: AdjustablePlanVariables;
}

@Component({
	selector: 'eync-pyl-preview-variables',
	templateUrl: './preview-variables.component.html',
	styleUrls: ['./preview-variables.component.less']
})
export class PreviewVariablesComponent implements OnInit {

	@Input() form: FormGroup;
	adjustableVariable: AdjustablePlanVariables = AdjustablePlanVariables.EXPENSES;
	EySliderTypeEnum = EySliderTypeEnum;
	timeSliderMaxValue = 18;

	options: AdjustableVariable[] = [
		{
			label: 'Monthly expenses',
			header: 'Ongoing monthly expenses to cover',
			popover: 'These are the monthly expenses that you expect your beneficiary to incur that you want to cover. Example of these include rent or mortgage payments, utilities, insurance, groceries, education and childcare costs.',
			type: AdjustablePlanVariables.EXPENSES,
		},
		{
			label: 'Time',
			header: 'Years life insurance proceeds need to cover expenses',
			popover: 'In the event of your death, you beneficiary may rely on your life insurance proceeds to cover their annual expenses. Enter the number of years for which you would like to provide coverage.',
			type: AdjustablePlanVariables.TIME,
		},
	];

	private backup = {
		monthlyExpensesToCover: 0,
		yearsToCover: 0
	};

	constructor() {
	}

	ngOnInit() {
		this.backup.monthlyExpensesToCover = this.form.get('ongoingExpenses').get('monthlyExpensesToCover').value;
		this.backup.yearsToCover = this.form.get('ongoingExpenses').get('yearsToCover').value;
		this.timeSliderMaxValue = this.form.get('ongoingExpenses').get('yearsToCover').value > 18 ? this.form.get('ongoingExpenses').get('yearsToCover').value : 18;
	}

	restoreExpensesValue() {
		this.updateExpensesValue(this.backup.monthlyExpensesToCover);
	}

	updateExpensesValue($event: number) {
		this.form.get('ongoingExpenses').get('monthlyExpensesToCover').setValue($event);
	}

	restoreTimeValue() {
		this.updateTimeValue(this.backup.yearsToCover);
	}

	updateTimeValue($event: number) {
		this.form.get('ongoingExpenses').get('yearsToCover').setValue($event);
	}
}
